<template>
  <div id="app">
    <globe-menu @click:menu-item="menuItemSelected"></globe-menu>
  </div>
</template>

<script>

export default {
  name: 'app',
  mounted () {
    if (this.$router.currentRoute.fullPath === '/') {
      this.createInitialView()
    } else {
      // Fetch API by name
      const parent = { title: 'NotFoundView', description: 'NotFoundView' }
      const children = [{ title: 'Item7' }, { title: 'Item8' }, { title: 'Item9' }]

      this.$globeMenu.createView(parent, children, this.$router.currentRoute.fullPath)
    }
  },
  methods: {
    createInitialView () {
      const parent = { title: 'TestView', description: 'TestView' }
      const children = [{ title: 'Item1' }, { title: 'Item2' }]

      this.$globeMenu.createView(parent, children)
    },
    menuItemSelected (item) {
      const parent = { title: 'TestChildView', description: 'TestChildView' }
      const children = [{ title: 'Item3' }, { title: 'Item4' }]

      this.$globeMenu.createView(parent, children)
    }
    // Fetch data and pass to globeMenu
    // Tell globeMenu to create Route with component
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  height: 100vh;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>
